export const isCostCentersEnabled = () => {
  return process.env.VUE_APP_SHOW_COST_CENTERS === 'true';
};
